import { Component, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslateService } from '@ngx-translate/core';
import { interval } from 'rxjs';
import { AuthService } from './shared/services/auth.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {


  sessionTimeLeft: any = 0;
  progressValue: number = 100;
  private ping = interval(5000);
  hasClaims = false;
  constructor(private translate: TranslateService, private snack: MatSnackBar, private authService: AuthService) {

    let currentLanguage;

    if (localStorage.getItem('localeId') !== null) {
      currentLanguage = localStorage.getItem('localeId');
    } else {
      currentLanguage = 'fr';
    }

    // this language will be used as a fallback when a translation isn't found in the current language
    this.translate.setDefaultLang(currentLanguage);

    // the lang to use, if the lang isn't available, it will use the current loader to get them
    this.translate.use(currentLanguage);
  }


  ngOnInit(){
    this.ping.subscribe(() => {
      if(this.authService.getToken()){
        const claims: any = this.authService.decodeToken(this.authService.getToken())
        this.hasClaims = true;
        const isTokenExpired = this.isExpiredToken(claims)
        if(isTokenExpired){
          this.authService.signOut();
        }
      }else{
        this.hasClaims = false;
      }

    });
  }


  isExpiredToken(claims: any) {
    const d = new Date().getTime() / 1000;
    const expiresAt = new Date(claims.exp * 1000).getTime() / 1000;
    this.sessionTimeLeft = expiresAt - d;//time left in seconds
    if (this.sessionTimeLeft <= 0) {
    console.log("session expired ! at :", this.sessionTimeLeft, ". loging out ...")
    this.progressValue = 0;
    const msg = this.translate.instant('iap_reconnect.desc');
    this.snack.open(msg, undefined, {
      duration: 3000,
    });
    this.sessionTimeLeft = null;
    return true;
    }
    this.progressValue = (this.sessionTimeLeft / 3600) * 100;
    return false;
  }
}
